var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg400(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 193,
    viewBox: "0 0 451 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.1 16.0001V32.2001H193.4V2.1001H119.9V175.5H193.4L374.9 176.6V16.0001H296.1Z",
    fill: "url(#paint0_linear_3_1789)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.3 26.9001H307.7C307 26.9001 306.5 26.3001 306.5 25.7001C306.5 25.0001 307.1 24.5001 307.7 24.5001H356.3C357 24.5001 357.5 25.1001 357.5 25.7001C357.5 26.3001 356.9 26.9001 356.3 26.9001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M356.3 36.5001H307.7C307 36.5001 306.5 35.9001 306.5 35.3001C306.5 34.6001 307.1 34.1001 307.7 34.1001H356.3C357 34.1001 357.5 34.7001 357.5 35.3001C357.5 35.9001 356.9 36.5001 356.3 36.5001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.3 46.1001H307.7C307 46.1001 306.5 45.5001 306.5 44.9001C306.5 44.2001 307.1 43.7001 307.7 43.7001H356.3C357 43.7001 357.5 44.3001 357.5 44.9001C357.5 45.6001 356.9 46.1001 356.3 46.1001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M356.3 55.7001H307.7C307 55.7001 306.5 55.1001 306.5 54.5001C306.5 53.8001 307.1 53.3001 307.7 53.3001H356.3C357 53.3001 357.5 53.9001 357.5 54.5001C357.5 55.2001 356.9 55.7001 356.3 55.7001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M356.3 65.3001H307.7C307 65.3001 306.5 64.7001 306.5 64.1001C306.5 63.4001 307.1 62.9001 307.7 62.9001H356.3C357 62.9001 357.5 63.5001 357.5 64.1001C357.5 64.8001 356.9 65.3001 356.3 65.3001Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M356.3 75.0001H307.7C307 75.0001 306.5 74.4001 306.5 73.8001C306.5 73.1001 307.1 72.6001 307.7 72.6001H356.3C357 72.6001 357.5 73.2001 357.5 73.8001C357.5 74.4001 356.9 75.0001 356.3 75.0001Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.601 11.2001H128.301V17.5001H134.601V11.2001Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.3 11.2001H141V17.5001H147.3V11.2001Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.101 11.2001H153.801V17.5001H160.101V11.2001Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 11.2001H166.5V17.5001H172.8V11.2001Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.601 26.9001H128.301V33.2001H134.601V26.9001Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.3 26.9001H141V33.2001H147.3V26.9001Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160.101 26.9001H153.801V33.2001H160.101V26.9001Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 26.9001H166.5V33.2001H172.8V26.9001Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.601 42.6001H128.301V48.9001H134.601V42.6001Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M147.3 42.6001H141V48.9001H147.3V42.6001Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M160.101 42.6001H153.801V48.9001H160.101V42.6001Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 42.6001H166.5V48.9001H172.8V42.6001Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M362.201 139.7C357.001 150.9 349.901 150.9 347.601 150.9C342.001 150.9 337.301 147.4 333.801 140.4C329.501 132 327.301 119.4 327.301 103.9C327.301 103.7 327.301 103.5 327.301 103.3H297.601C297.601 103.4 297.601 103.6 297.601 103.7C297.801 125.6 302.301 143.9 310.701 156.5C319.401 169.6 331.801 176.5 346.601 176.5C362.901 176.5 376.201 169.4 385.101 156.1C393.401 143.5 397.701 125.7 397.901 103.3H368.201C368.101 118.9 366.001 131.5 362.201 139.7Z",
    fill: "#5571E9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M399.1 50.2001C390.5 37.0001 377.8 30.1001 362.2 30.1001C346.8 30.1001 333.9 37.0001 324.7 50.1001C315.7 62.9001 311 81.3001 310.9 103.3H340.6C340.7 87.6001 343 74.8001 347.4 66.3001C351 59.3001 355.7 55.7001 361.1 55.7001C368.7 55.7001 381.5 61.8001 381.5 102.7C381.5 102.9 381.5 103.1 381.5 103.3H411.2C411.2 102.8 411.2 102.4 411.2 101.9C411.3 80.1001 407.2 62.6001 399.1 50.2001Z",
    fill: "#5571E9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M255 139.7C249.8 150.9 242.7 150.9 240.4 150.9C234.8 150.9 230.1 147.4 226.6 140.4C222.3 132 220.1 119.4 220.1 103.9C220.1 103.7 220.1 103.5 220.1 103.3H190.4C190.4 103.4 190.4 103.6 190.4 103.7C190.6 125.6 195.1 143.9 203.5 156.5C212.2 169.6 224.6 176.5 239.4 176.5C255.7 176.5 269 169.4 277.9 156.1C286.2 143.5 290.5 125.7 290.7 103.3H261C260.9 118.9 258.8 131.5 255 139.7Z",
    fill: "#5571E9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M291.9 50.2001C283.3 37.0001 270.6 30.1001 255 30.1001C239.6 30.1001 226.7 37.0001 217.5 50.1001C208.5 62.9001 203.8 81.3001 203.7 103.3H233.4C233.5 87.6001 235.8 74.8001 240.2 66.3001C243.8 59.3001 248.5 55.7001 253.9 55.7001C261.5 55.7001 274.3 61.8001 274.3 102.7C274.3 102.9 274.3 103.1 274.3 103.3H304C304 102.8 304 102.4 304 101.9C304.1 80.1001 300 62.6001 291.9 50.2001Z",
    fill: "#5571E9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3999 172.5C71.4999 172.5 70.5999 171.8 70.4999 170.8L51.6999 3.7C51.5999 2.7 52.2999 1.69999 53.3999 1.59999C54.3999 1.49999 55.3999 2.19999 55.4999 3.29999L74.2999 170.4C74.3999 171.4 73.6999 172.4 72.5999 172.5C72.4999 172.5 72.4999 172.5 72.3999 172.5Z",
    fill: "#8C9EA5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M123.4 172.5C122.5 172.5 121.6 171.8 121.5 170.8L102.7 3.7C102.6 2.7 103.3 1.69999 104.4 1.59999C105.4 1.49999 106.4 2.19999 106.5 3.29999L125.3 170.4C125.4 171.4 124.7 172.4 123.6 172.5C123.5 172.5 123.5 172.5 123.4 172.5Z",
    fill: "#8C9EA5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 22.8H55.4996C54.4996 22.8 53.5996 22 53.5996 20.9C53.5996 19.9 54.3996 19 55.4996 19H106.5C107.5 19 108.4 19.8 108.4 20.9C108.4 22 107.6 22.8 106.5 22.8Z",
    fill: "#8C9EA5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M107.6 39.4H57.6998C56.6998 39.4 55.7998 38.6 55.7998 37.5C55.7998 36.5 56.5998 35.6 57.6998 35.6H107.6C108.6 35.6 109.5 36.4 109.5 37.5C109.5 38.6 108.6 39.4 107.6 39.4Z",
    fill: "#8C9EA5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M108.7 56H59.8004C58.8004 56 57.9004 55.2 57.9004 54.1C57.9004 53.1 58.7004 52.2 59.8004 52.2H108.7C109.7 52.2 110.6 53 110.6 54.1C110.5 55.1 109.7 56 108.7 56Z",
    fill: "#8C9EA5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M112.1 72.6H61.9996C60.9996 72.6 60.0996 71.8 60.0996 70.7C60.0996 69.7 60.8996 68.8 61.9996 68.8H112.1C113.1 68.8 114 69.6 114 70.7C114 71.7 113.2 72.6 112.1 72.6Z",
    fill: "#8C9EA5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M114 89.2H63.6002C62.6002 89.2 61.7002 88.4 61.7002 87.3C61.7002 86.3 62.5002 85.4 63.6002 85.4H114C115 85.4 115.9 86.2 115.9 87.3C115.9 88.3 115 89.2 114 89.2Z",
    fill: "#8C9EA5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M115.9 105.7H65.4C64.4 105.7 63.5 104.9 63.5 103.8C63.5 102.8 64.3 101.9 65.4 101.9H115.9C116.9 101.9 117.8 102.7 117.8 103.8C117.8 104.9 116.9 105.7 115.9 105.7Z",
    fill: "#8C9EA5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 7H50.0996C48.1996 7 46.5996 5.4 46.5996 3.5C46.5996 1.6 48.1996 0 50.0996 0H104.9C106.8 0 108.4 1.6 108.4 3.5C108.4 5.4 106.9 7 104.9 7Z",
    fill: "#B0BEC5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3997 172.5C83.2997 172.5 83.2997 172.5 83.1997 172.5C82.1997 172.4 81.3997 171.5 81.4997 170.4L100.3 3.30001C100.4 2.30001 101.3 1.50001 102.4 1.60001C103.4 1.70001 104.2 2.60002 104.1 3.70002L85.2997 170.8C85.1997 171.8 84.3997 172.5 83.3997 172.5Z",
    fill: "#B0BEC5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3997 172.5C32.2997 172.5 32.2997 172.5 32.1997 172.5C31.1997 172.4 30.3997 171.5 30.4997 170.4L49.2997 3.30001C49.3997 2.30001 50.2997 1.50001 51.3997 1.60001C52.3997 1.70001 53.1997 2.60002 53.0997 3.70002L34.2997 170.8C34.1997 171.8 33.3997 172.5 32.3997 172.5Z",
    fill: "#B0BEC5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M100.299 22.8H49.2994C48.2994 22.8 47.3994 22 47.3994 20.9C47.3994 19.9 48.1994 19 49.2994 19H100.299C101.299 19 102.199 19.8 102.199 20.9C102.199 22 101.399 22.8 100.299 22.8Z",
    fill: "#B0BEC5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1994 39.4H48.2994C47.2994 39.4 46.3994 38.6 46.3994 37.5C46.3994 36.5 47.1994 35.6 48.2994 35.6H98.1994C99.1994 35.6 100.099 36.4 100.099 37.5C100.099 38.6 99.1994 39.4 98.1994 39.4Z",
    fill: "#B0BEC5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0998 56H47.1998C46.1998 56 45.2998 55.2 45.2998 54.1C45.2998 53.1 46.0998 52.2 47.1998 52.2H96.0998C97.0998 52.2 97.9998 53 97.9998 54.1C97.8998 55.1 97.0998 56 96.0998 56Z",
    fill: "#B0BEC5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8994 72.6H43.7994C42.7994 72.6 41.8994 71.8 41.8994 70.7C41.8994 69.7 42.6994 68.8 43.7994 68.8H93.8994C94.8994 68.8 95.7994 69.6 95.7994 70.7C95.6994 71.7 94.8994 72.6 93.8994 72.6Z",
    fill: "#B0BEC5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3 89.2H41.9C40.9 89.2 40 88.4 40 87.3C40 86.3 40.8 85.4 41.9 85.4H92.3C93.3 85.4 94.2 86.2 94.2 87.3C94.2 88.3 93.3 89.2 92.3 89.2Z",
    fill: "#B0BEC5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4996 105.7H39.9996C38.9996 105.7 38.0996 104.9 38.0996 103.8C38.0996 102.8 38.8996 101.9 39.9996 101.9H90.4996C91.4996 101.9 92.3996 102.7 92.3996 103.8C92.2996 104.9 91.4996 105.7 90.4996 105.7Z",
    fill: "#B0BEC5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M137.7 124.7L200.1 83.5001L205.1 80.2001L201.8 75.2001L191.3 59.3L189.6 56.7001L186.5 56.6001L85.2 53.9001L83.3 53.8L81.7 54.8L72 61.2001L67 64.5001L70.3 69.5001L100.3 114.9L75.8 131.1L70.8 134.4L74.1 139.4L83.3 153.3L86.6 158.3L91.6 155L116.1 138.8L122.8 149L126.1 154L131.1 150.7L142.6 143.1L147.6 139.8L144.3 134.8L137.7 124.7ZM108.1 79.8L151 81.5001L121.9 100.7L108.1 79.8Z",
    fill: "#5571E9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8002 150.7C41.2002 150.7 34.2002 157.7 34.2002 166.3C34.2002 174.9 41.2002 181.9 49.8002 181.9H181.6V150.7H49.8002Z",
    fill: "#B0BEC5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8002 150.7C41.2002 150.7 34.2002 157.7 34.2002 166.3C34.2002 174.9 41.2002 181.9 49.8002 181.9H181.6V150.7H49.8002Z",
    fill: "url(#paint1_linear_3_1789)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M187.53 180.743C195.503 177.477 199.318 168.366 196.052 160.393C192.786 152.42 183.675 148.605 175.702 151.871C167.729 155.137 163.913 164.248 167.18 172.221C170.446 180.194 179.557 184.009 187.53 180.743Z",
    fill: "#CFD8DC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 177.5C187.786 177.5 192.8 172.486 192.8 166.3C192.8 160.114 187.786 155.1 181.6 155.1C175.415 155.1 170.4 160.114 170.4 166.3C170.4 172.486 175.415 177.5 181.6 177.5Z",
    fill: "#B0BEC5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M181.6 177.5C187.786 177.5 192.8 172.486 192.8 166.3C192.8 160.114 187.786 155.1 181.6 155.1C175.415 155.1 170.4 160.114 170.4 166.3C170.4 172.486 175.415 177.5 181.6 177.5Z",
    fill: "url(#paint2_linear_3_1789)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0004 123C24.4004 123 17.4004 130 17.4004 138.6C17.4004 147.2 24.4004 154.2 33.0004 154.2H164.8V123H33.0004Z",
    fill: "#B0BEC5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0004 123C24.4004 123 17.4004 130 17.4004 138.6C17.4004 147.2 24.4004 154.2 33.0004 154.2H164.8V123H33.0004Z",
    fill: "url(#paint3_linear_3_1789)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M175.855 149.635C181.947 143.542 181.947 133.665 175.855 127.573C169.763 121.481 159.886 121.481 153.793 127.573C147.701 133.665 147.701 143.542 153.793 149.635C159.886 155.727 169.763 155.727 175.855 149.635Z",
    fill: "#CFD8DC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M164.801 149.8C170.986 149.8 176.001 144.786 176.001 138.6C176.001 132.414 170.986 127.4 164.801 127.4C158.615 127.4 153.601 132.414 153.601 138.6C153.601 144.786 158.615 149.8 164.801 149.8Z",
    fill: "#B0BEC5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M164.801 149.8C170.986 149.8 176.001 144.786 176.001 138.6C176.001 132.414 170.986 127.4 164.801 127.4C158.615 127.4 153.601 132.414 153.601 138.6C153.601 144.786 158.615 149.8 164.801 149.8Z",
    fill: "url(#paint4_linear_3_1789)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 150.7C7.00001 150.7 0 157.7 0 166.3C0 174.9 7.00001 181.9 15.6 181.9H147.4V150.7H15.6Z",
    fill: "#B0BEC5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M153.472 180.708C161.407 177.351 165.119 168.198 161.762 160.263C158.406 152.328 149.252 148.616 141.317 151.973C133.382 155.329 129.67 164.483 133.027 172.418C136.384 180.353 145.537 184.065 153.472 180.708Z",
    fill: "#CFD8DC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M147.4 177.5C153.586 177.5 158.6 172.486 158.6 166.3C158.6 160.114 153.586 155.1 147.4 155.1C141.215 155.1 136.2 160.114 136.2 166.3C136.2 172.486 141.215 177.5 147.4 177.5Z",
    fill: "#B0BEC5"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M147.4 177.5C153.586 177.5 158.6 172.486 158.6 166.3C158.6 160.114 153.586 155.1 147.4 155.1C141.215 155.1 136.2 160.114 136.2 166.3C136.2 172.486 141.215 177.5 147.4 177.5Z",
    fill: "url(#paint5_linear_3_1789)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M259.6 176.4C253.6 176.4 250.7 168.9 255.3 165C256 164.4 256.8 163.9 257.6 163.5C260.9 161.8 264.8 161.7 268.3 163C270.5 163.8 273 163.3 274.8 161.8C277.4 159.5 281 158.2 284.6 158.1C288 158 291.3 158.8 294.6 159.8C297.2 160.7 300.2 159.7 301.8 157.5C308.8 147.9 320.2 141.8 332 139.7C339.1 138.4 346.7 138.4 353.4 141C358.5 143 363 146.6 365.8 151.2C367.2 153.5 369.9 154.7 372.6 154.2C377.7 153.2 383.5 155.1 387.1 158.9C389.2 161.1 392.4 161.7 395 160.3C397.3 159 399.8 158.1 402.5 158C405.5 157.9 408.7 159.2 410.7 161.4C412.3 163.2 414.7 163.9 417.1 163.5C418.9 163.2 420.8 163.5 422.4 164.4C422.4 164.4 422.5 164.4 422.5 164.5C428.2 167.8 425.7 176.5 419.1 176.5L259.6 176.4Z",
    fill: "#CFD8DC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M259.6 176.4C253.6 176.4 250.7 168.9 255.3 165C256 164.4 256.8 163.9 257.6 163.5C260.9 161.8 264.8 161.7 268.3 163C270.5 163.8 273 163.3 274.8 161.8C277.4 159.5 281 158.2 284.6 158.1C288 158 291.3 158.8 294.6 159.8C297.2 160.7 300.2 159.7 301.8 157.5C308.8 147.9 320.2 141.8 332 139.7C339.1 138.4 346.7 138.4 353.4 141C358.5 143 363 146.6 365.8 151.2C367.2 153.5 369.9 154.7 372.6 154.2C377.7 153.2 383.5 155.1 387.1 158.9C389.2 161.1 392.4 161.7 395 160.3C397.3 159 399.8 158.1 402.5 158C405.5 157.9 408.7 159.2 410.7 161.4C412.3 163.2 414.7 163.9 417.1 163.5C418.9 163.2 420.8 163.5 422.4 164.4C422.4 164.4 422.5 164.4 422.5 164.5C428.2 167.8 425.7 176.5 419.1 176.5L259.6 176.4Z",
    fill: "url(#paint6_linear_3_1789)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M429 169.6H249.5C248 169.6 246.8 170.8 246.8 172.3V179.3C246.8 180.8 248 182 249.5 182H429C430.5 182 431.7 180.8 431.7 179.3V172.3C431.7 170.8 430.5 169.6 429 169.6Z",
    fill: "#455A64"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28.127 113.194L20.627 113.208L20.7742 192.008L28.2742 191.994L28.127 113.194Z",
    fill: "#37474F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2998 188.7V189.6C15.2998 190.9 16.3998 192 17.6998 192H31.4998C32.7998 192 33.8998 190.9 33.8998 189.6V188.7H15.2998Z",
    fill: "#37474F"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3998 185.1H20.7998L15.2998 188.7H33.9998L28.3998 185.1Z",
    fill: "#455A64"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4004 185.1L28.2004 113.2H25.4004L25.6004 185.1L28.3004 188.7V189.6C28.3004 190.9 27.2004 192 25.9004 192H31.6004C32.9004 192 34.0004 190.9 34.0004 189.6V188.7L28.4004 185.1Z",
    fill: "url(#paint7_linear_3_1789)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4998 104.1C33.4998 99.1 29.3998 95 24.3998 95C19.3998 95 15.2998 99.1 15.2998 104.1C15.2998 109.1 19.3998 113.2 24.3998 113.2C29.3998 113.2 33.4998 109.1 33.4998 104.1Z",
    fill: "#E53935"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4 113.2C29.4 113.2 33.5 109.1 33.5 104.1C33.5 102.5 33.1 101 32.3 99.7L20 112C21.3 112.7 22.8 113.2 24.4 113.2Z",
    fill: "url(#paint8_linear_3_1789)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M444.23 115.594L436.93 115.607L437.071 191.307L444.371 191.294L444.23 115.594Z",
    fill: "#37474F"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M431.6 188V188.8C431.6 190.1 432.7 191.2 434 191.2H447.4C448.7 191.2 449.8 190.1 449.8 188.8V188H431.6Z",
    fill: "#37474F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M444.4 184.5H437L431.6 188H449.8L444.4 184.5Z",
    fill: "#455A64"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M444.4 184.5L444.2 115.6H441.5L441.7 184.5L444.3 188V188.8C444.3 190.1 443.2 191.2 441.9 191.2H447.4C448.7 191.2 449.8 190.1 449.8 188.8V188L444.4 184.5Z",
    fill: "url(#paint9_linear_3_1789)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M449.299 106.8C449.299 101.9 445.299 98 440.499 98C435.599 98 431.699 102 431.699 106.8C431.699 111.7 435.699 115.6 440.499 115.6C445.399 115.6 449.299 111.6 449.299 106.8Z",
    fill: "#E53935"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M440.499 115.6C445.399 115.6 449.299 111.6 449.299 106.8C449.299 105.2 448.899 103.8 448.199 102.5L436.199 114.5C437.499 115.2 438.899 115.6 440.499 115.6Z",
    fill: "url(#paint10_linear_3_1789)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M439.299 102.5C439.299 103.4 438.599 104.2 437.599 104.2C436.599 104.2 435.899 103.5 435.899 102.5C435.899 101.6 436.599 100.8 437.599 100.8C438.499 100.8 439.299 101.5 439.299 102.5Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M450.885 115.593L14.085 116.408L14.1158 132.908L450.916 132.093L450.885 115.593Z",
    fill: "#F5D100"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8996 116.4L16.3996 132.9H14.0996V123.5L21.2996 116.4H32.8996Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7992 116.3L38.2992 132.9H26.6992L43.0992 116.3H54.7992Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7 116.3L60.2 132.8H48.5L65 116.3H76.7Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5994 116.2L82.0994 132.8H70.3994L86.8994 116.3L98.5994 116.2Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 116.2L104 132.7L92.2998 132.8L108.8 116.2H120.5Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M142.299 116.2L125.899 132.7H114.199L130.699 116.2H142.299Z",
    fill: "#263238"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M164.2 116.1L147.8 132.7H136.1L152.6 116.1H164.2Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M186.1 116.1L169.6 132.6H158L174.4 116.1H186.1Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M208 116L191.5 132.6H179.8L196.3 116H208Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M229.899 116L213.399 132.5L201.699 132.6L218.199 116H229.899Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M251.8 115.9L235.3 132.5H223.6L240.1 116L251.8 115.9Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M273.7 115.9L257.2 132.4L245.5 132.5L262 115.9H273.7Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M295.499 115.9L279.099 132.4H267.399L283.899 115.9H295.499Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M317.4 115.8L300.9 132.4H289.3L305.8 115.8H317.4Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M339.299 115.8L322.799 132.3H311.199L327.599 115.8H339.299Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M361.2 115.7L344.7 132.3H333L349.5 115.8L361.2 115.7Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M383.099 115.7L366.599 132.2L354.899 132.3L371.399 115.7H383.099Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M405 115.7L388.5 132.2H376.8L393.3 115.7H405Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M426.899 115.6L410.399 132.2H398.699L415.199 115.6H426.899Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M448.7 115.6L432.3 132.1H420.6L437.1 115.6H448.7Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M450.9 123.6L451 132.1H442.5L450.9 123.6Z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0996 132.9L451 132.1L450.9 123.7L14.0996 124.5V132.9Z",
    fill: "url(#paint11_linear_3_1789)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_1789",
    x1: 247.383,
    y1: 175.173,
    x2: 247.383,
    y2: -74.3306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D7F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_1789",
    x1: 107.922,
    y1: 140.702,
    x2: 107.922,
    y2: 173.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_1789",
    x1: 209.647,
    y1: 166.312,
    x2: 169.165,
    y2: 166.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_1789",
    x1: 91.1276,
    y1: 121.13,
    x2: 91.1276,
    y2: 160.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_1789",
    x1: 192.853,
    y1: 138.568,
    x2: 152.371,
    y2: 138.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_1789",
    x1: 175.476,
    y1: 166.312,
    x2: 134.995,
    y2: 166.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_1789",
    x1: 356.633,
    y1: 149.525,
    x2: 311.003,
    y2: 203.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00099143,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_1789",
    x1: 4.69604,
    y1: 143.134,
    x2: 66.6437,
    y2: 169.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_1789",
    x1: 26.7011,
    y1: 96.2249,
    x2: 26.7363,
    y2: 114.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_1789",
    x1: 421.68,
    y1: 144.325,
    x2: 481.244,
    y2: 169.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3_1789",
    x1: 442.73,
    y1: 99.1465,
    x2: 442.765,
    y2: 117.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3_1789",
    x1: 144.5,
    y1: 4.89583,
    x2: 279.119,
    y2: 193.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00065435,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg400);
export default __webpack_public_path__ + "static/media/400.4e46e304dcfdcae89fcfb902d8863816.svg";
export { ForwardRef as ReactComponent };